/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import zip from 'lodash/zip';
import map from 'lodash/map';
import { injectIntl } from 'react-intl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  normalizeDevEUI,
  normalizeDevAddr,
} from 'lorautils/IdUtils';
import imgConnected from './images/connected.svg';


const defaultProps = {
  onZoom: () => {},
  onDrag: () => {},
};

const propTypes = {
  devices: React.PropTypes.array.isRequired,
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  onZoom: React.PropTypes.func,
  onDrag: React.PropTypes.func,
};


class DeviceMap extends React.Component {

  static getCenterAndZoom(points) {
    let span = 0.0001;
    let center = points[0];
    points.forEach((x) => {
      if (center.lat !== x.lat || center.lng !== x.lng) {
        center = new BMap.Point(
          (center.lng + x.lng) / 2,
          (center.lat + x.lat) / 2,
        );
      }
      points.forEach((y) => {
        span = Math.max(span, Math.max(
          Math.abs(x.lat - y.lat),
          Math.abs(x.lng - y.lng),
        ));
      });
    });
    let zoom = 2;
    if (span < 0.001) {
      zoom = 16;
    } else if (span < 0.1) {
      zoom = 14;
    } else if (span < 0.5) {
      zoom = 11;
    } else if (span < 1) {
      zoom = 8;
    } else if (span < 10) {
      zoom = 6;
    } else if (span < 20) {
      zoom = 5;
    }
    return [center, zoom];
  }

  static transform(devices = []) {
    return devices
      .filter((gw) => {
        const { lat = '', lng = '' } = gw;
        return lat !== '' && lng !== '';
      })
      .map(gw => ({
        ...gw,
        point: new BMap.Point(gw.lng, gw.lat),
      }));
  }

  constructor(props) {
    super(props);
    this.markers = [];
    this.listeners = [];
    this.devices = props.devices;
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.map');
  }

  componentDidMount() {
    let tries = 0;
    const init = () => {
      try {
        this.initMap();
        this.updateData();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
  }

  componentWillReceiveProps(nextProps) {
    const { devices } = nextProps;
    if (devices !== this.props.devices) {
      this.devices = devices;
      if (this.map) {
        this.map.clearOverlays();
        this.updateData();
      }
    }
  }

  componentWillUnmount() {
    map(zip(this.markers, this.listeners), ([marker, listener]) => {
      marker.removeEventListener('click', listener);
    });
    $('#devicemap').empty();
  }

  initMap() {
    this.map = new BMap.Map('devicemap');
    this.map.setMapStyle({ features: [] });
    this.map.setMaxZoom(16);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', () => this.props.onZoom(this.map));
    this.map.addEventListener('dragend', () => this.props.onDrag(this.map));
  }

  updateData() {
    this.devices = DeviceMap.transform(this.devices);
    this.devices.forEach((obj) => {
      this.addMarker(obj);
    });

    const points = this.devices.map(x => x.point);
    if (points.length === 1) {
      this.map.centerAndZoom(points[0], 16);
    } else if (points.length > 0) {
      // decide max span with at most 100 points
      const [center, zoom] = DeviceMap.getCenterAndZoom(points.slice(0, 100));
      this.map.centerAndZoom(center, zoom);
    } else {
      this.map.centerAndZoom('深圳', 1);
    }
  }

  info(obj) {
    return (
`
<div>
  <h4 style="font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, PingFang SC, Source Han Sans CN, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif; font-weight: 300; font-size: 14px;">
    ${this.intlMsg.msg('id')}&nbsp;<a id="infowin">${obj.id}</a>
  </h4>
  <dl class="dl-horizontal" style="font-size: 12px; background-color: #eeeeee; padding: 15px 5px; border-radius: 2px; border: 1px solid #efefef;">
    <div style="padding: 5px 0;">
      <span style="width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;">
        ${this.intlMsg.msg('deveui')}
      </span>
      <span>${normalizeDevEUI(obj.deveui)}</span>
    </div>
    <div style="padding: 5px 0;">
      <span style="width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;">
        ${this.intlMsg.msg('devaddr')}
      </span>
      <span>${normalizeDevAddr(obj.devaddr)}</span>
    </div>
    <div style="padding: 5px 0;">
      <span style="width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;">
        ${this.intlMsg.msg('name')}
      </span>
      <span>${obj.name}</span>
    </div>
    <div style="padding: 5px 0;">
      <span style="width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;">
        ${this.intlMsg.msg('address')}
      </span>
      <span>${obj.area} ${obj.address}</span>
    </div>
  </dl>
</div>
`
    );
  }

  addMarker(item) {
    const opts = {
      width: 400,
      height: 180,
      title: '',
      enableMessage: true,
    };

    const { pushState } = this.props;
    const that = this;
    const openInfo = () => {
      const info = that.info(item);
      const infoWin = new BMap.InfoWindow(info, opts);
      this.map.openInfoWindow(infoWin, item.point);
      setTimeout(() => {
        $('#infowin').click(() => {
          pushState(`/application/${item.appeui}/devices/${item.id}`);
        });
      }, 300);
    };

    const icon = new BMap.Icon(imgConnected, new BMap.Size(48, 48));
    const marker = new BMap.Marker(item.point, { icon });
    marker.addEventListener('click', openInfo);
    this.map.addOverlay(marker);
    this.markers.push(marker);
    this.listeners.push(openInfo);
  }

  render() {
    return <div id="devicemap" style={{ height: '100%', width: '100%' }} />;
  }
}


DeviceMap.defaultProps = defaultProps;
DeviceMap.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null, mapDispatchToProps)(injectIntl(DeviceMap));




// WEBPACK FOOTER //
// ./src/components/DeviceMap/index.jsx